import { Description, Edit } from '@mui/icons-material';
import AppAvatar from 'components/avatars/AppAvatar';
import FlexBox from 'components/flexbox/FlexBox';
import { Small } from 'components/Typography';

const columnShape = (onEditClick, onBusinessInfoClick, onUserInfoClick) => [
  {
    minWidth: 200,
    Header: '이름',
    accessor: 'name',
    Cell: ({ row }) => {
      const { name, nickname, avatar } = row.original;
      const clickable = typeof onUserInfoClick === 'function';
      const handleNavigate = () => {
        if (clickable) {
          onUserInfoClick(row.original);
        }
      };
      const handleKeyDown = event => {
        if (!clickable) return;
        if (
          event.key === 'Enter' ||
          event.key === ' ' ||
          event.key === 'Spacebar'
        ) {
          event.preventDefault();
          onUserInfoClick(row.original);
        }
      };
      return (
        <FlexBox
          alignItems="center"
          gap={1.5}
          onClick={handleNavigate}
          onKeyDown={handleKeyDown}
          role={clickable ? 'button' : undefined}
          tabIndex={clickable ? 0 : undefined}
          sx={{ cursor: clickable ? 'pointer' : 'default' }}
        >
          <AppAvatar
            src={avatar}
            sx={{ width: 44, height: 44, cursor: 'inherit' }}
          />
          <FlexBox flexDirection="column" gap={0.5}>
            <Small sx={{ color: '#2A2A2A' }}>이름 : {name}</Small>
            <Small sx={{ color: '#2A2A2A' }}>닉네임 : {nickname}</Small>
          </FlexBox>
        </FlexBox>
      );
    },
  },
  {
    minWidth: 140,
    Header: '작성글/댓글',
    accessor: 'posts',
    Cell: ({ row }) => {
      const { posts, comments } = row.original;
      return (
        <FlexBox flexDirection="column" gap={0.5}>
          <Small sx={{ color: '#2A2A2A' }}>작성 게시글 수 : {posts}</Small>
          <Small sx={{ color: '#2A2A2A' }}>작성 댓글 수 : {comments}</Small>
        </FlexBox>
      );
    },
  },
  {
    minWidth: 120,
    Header: '권한/파트너스',
    accessor: 'permission',
    Cell: ({ row }) => {
      const { permission, partnership } = row.original;
      return (
        <FlexBox flexDirection="column" gap={0.5}>
          <Small sx={{ color: '#2A2A2A' }}>권한 등급 : {permission}</Small>
          <Small sx={{ color: '#2A2A2A' }}>파트너스 : {partnership}</Small>
        </FlexBox>
      );
    },
  },
  {
    minWidth: 200,
    Header: '연락처',
    accessor: 'email',
    Cell: ({ row }) => {
      const { email, phone } = row.original;
      return (
        <FlexBox flexDirection="column" gap={0.5}>
          <Small sx={{ color: '#2A2A2A' }}>{email}</Small>
          <Small sx={{ color: '#2A2A2A' }}>{phone}</Small>
        </FlexBox>
      );
    },
  },
  {
    minWidth: 130,
    Header: '회사/매출',
    accessor: 'company',
    Cell: ({ row }) => {
      const { company, sales } = row.original;
      return (
        <FlexBox flexDirection="column" gap={0.5}>
          <Small sx={{ color: '#2A2A2A' }}>회사 : {company}</Small>
          <Small sx={{ color: '#2A2A2A' }}>매출 : {sales}</Small>
        </FlexBox>
      );
    },
  },
  {
    minWidth: 130,
    Header: 'NICE/고용인원',
    accessor: 'niceScore',
    Cell: ({ row }) => {
      const { niceScore, employees } = row.original;
      return (
        <FlexBox flexDirection="column" gap={0.5}>
          <Small sx={{ color: '#2A2A2A' }}>NICE 점수 : {niceScore}</Small>
          <Small sx={{ color: '#2A2A2A' }}>고용인원 : {employees}</Small>
        </FlexBox>
      );
    },
  },
  {
    minWidth: 120,
    Header: '관리',
    Cell: ({ row }) => {
      return (
        <FlexBox flexDirection="column" gap={0.5} alignItems="flex-end">
          <FlexBox
            alignItems="center"
            gap={0.5}
            onClick={() => onEditClick && onEditClick(row.original)}
            sx={{ cursor: 'pointer' }}
          >
            <Small sx={{ color: '#3F68FF' }}>고객수정</Small>
            <Edit sx={{ fontSize: 16, color: '#3F68FF' }} />
          </FlexBox>
          <FlexBox
            alignItems="center"
            gap={0.5}
            onClick={() => onEditClick && onEditClick(row.original)}
            sx={{ cursor: 'pointer' }}
          >
            <Small sx={{ color: '#3F68FF' }}>사업자 정보</Small>
            <Description sx={{ fontSize: 16, color: '#3F68FF' }} />
          </FlexBox>
        </FlexBox>
      );
    },
  },
  // Hidden columns for filtering
  {
    Header: '',
    accessor: 'nickname',
    Cell: () => null,
  },
  {
    Header: '',
    accessor: 'phone',
    Cell: () => null,
  },
  {
    Header: '',
    accessor: 'customerType',
    Cell: () => null,
  },
  {
    Header: '',
    accessor: 'accountActive',
    Cell: () => null,
  },
];

export default columnShape;
